export default __webpack_public_path__ + "static/icons-bg-purple-1c64c84c6d6a57f971149a659093e8fe.svg";